// extracted by mini-css-extract-plugin
module.exports = {"media-gallery":"publisher-media_media-gallery__3Rfae","dropzone-message":"publisher-media_dropzone-message__HZg3_"};